import { useEffect, useState } from "react";
import {
  Button,
  Modal,
  Backdrop,
  Box,
  IconButton,
  Grid,
  Typography,
  ButtonBase,
  useTheme,
} from "@mui/material";
import { BCPXmark } from "../../icons/bcp/BCPIcons";
import ModalLoadingFull from "../../modals/ModalLoadingFull";
import { getData } from "../UtilityFunctions";
import { getEnvironmentVariable } from "../../../global/environmentVariables";

function ModalListItem({
  gameSystem,
  setGameSystemId,
  setActiveBanner,
  setActiveSystemName,
  screenWidth,
  handleChange,
  setOpen,
  name,
  valueType,
}) {
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [processing, setProcessing] = useState(true);
  const theme = useTheme();

  useEffect(() => {
    setProcessing(true);
    const go = async () => {
      try {
        if (gameSystem?.imageId) {
          let apiBanner = await getData(`/files/${gameSystem.imageId}`);
          setBackgroundImage(apiBanner);
        }
      } catch (err) {
        console.log(err);
      }
    };

    if (gameSystem.image?.cloudFrontDomain && gameSystem.image?.filename) {
      setBackgroundImage(
        `${gameSystem.image.cloudFrontDomain}${gameSystem.image.filename}`
      );
    } else if (gameSystem.imageId) {
      go();
    } else {
      setBackgroundImage(
        `${getEnvironmentVariable(
          "SYSTEM_IMAGES_CLOUDFRONT"
        )}/images/EventImage${theme?.palette?.mode === "dark" ? "Dark" : ""}.png`
      );
    }

    setProcessing(false);
    // eslint-disable-next-line
  }, []);

  return (
    <>
      {Boolean(processing) && <ModalLoadingFull />}

      <Grid
        item
        xs={12}
        sx={{ display: "flex", justifyContent: "center", alignItems: "center" }}
      >
        {backgroundImage ===
          `${getEnvironmentVariable(
            "SYSTEM_IMAGES_CLOUDFRONT"
          )}/images/EventImageDark.png` ||
        backgroundImage ===
          `${getEnvironmentVariable(
            "SYSTEM_IMAGES_CLOUDFRONT"
          )}/images/EventImage.png` ? (
          <ButtonBase
            focusRipple
            onClick={(e) => {
              e.target.name = name;
              e.target.value =
                valueType === "id" ? gameSystem.id : gameSystem.code;
              setGameSystemId(gameSystem.id);
              setActiveSystemName(gameSystem.name);
              setActiveBanner(backgroundImage);
              handleChange(e);
              setOpen(false);
            }}
            sx={{
              width: screenWidth > 900 ? "90vw" : "80vw",
              with: "auto",
              overflow: "hidden",
              borderRadius: 1,
              height: screenWidth > 900 ? "125px" : "75px", //"auto",
              position: "relative",
              textAlign: "center",
              color: "white",

              flexBasis: "100%",
              flexGrow: 0,

              background: `linear-gradient(0deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.6)), url(${backgroundImage})`,

              backgroundRepeat: "no-repeat",
              backgroundPosition: "center",
              backgroundSize: "cover",
            }}
          >
            <Typography
              variant="h4"
              sx={{
                padding: "100%",
                whiteSpace: "noWrap",
              }}
            >
              {gameSystem.name}
            </Typography>
          </ButtonBase>
        ) : (
          <ButtonBase
            focusRipple
            onClick={(e) => {
              e.target.name = name;
              e.target.value =
                valueType === "id" ? gameSystem.id : gameSystem.code;
              setGameSystemId(gameSystem.id);
              setActiveSystemName(gameSystem.name);
              setActiveBanner(backgroundImage);
              handleChange(e);
              setOpen(false);
            }}
            sx={{
              width: screenWidth > 900 ? "90vw" : "80vw",
              overflow: "hidden",
              borderRadius: 1,
            }}
          >
            <img
              src={backgroundImage?.url || backgroundImage}
              alt={gameSystem.name}
              style={{
                padding: "0 100%",
                maxHeight: screenWidth > 900 ? "125px" : "75px",
                borderRadius: 2,
              }}
            />
          </ButtonBase>
        )}
      </Grid>
    </>
  );
}

export default function GameSystemPickerModal({
  name,
  handleChange,
  gameSystems,
  valueType,
}) {
  const [gameSystemId, setGameSystemId] = useState(null);
  const [activeBanner, setActiveBanner] = useState(null);
  const [activeSystemName, setActiveSystemName] = useState(null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    function handleResize() {
      setScreenWidth(window.innerWidth);
    }
    window.addEventListener("resize", handleResize);
  });

  return (
    <>
      {(gameSystemId &&
        activeBanner ===
          `${getEnvironmentVariable(
            "SYSTEM_IMAGES_CLOUDFRONT"
          )}/images/EventImageDark.png`) ||
      (gameSystemId &&
        activeBanner ===
          `${getEnvironmentVariable(
            "SYSTEM_IMAGES_CLOUDFRONT"
          )}/images/EventImage.png`) ? (
        <Box sx={{ display: "flex", justifyContent: "center" }}>
          <ButtonBase
            focusRipple
            onClick={() => {
              setOpen(true);
            }}
            sx={{
              width: screenWidth > 900 ? "750px" : "336px",
              overflow: "hidden",
              borderRadius: 1,
              height: screenWidth > 900 ? "125px" : "80px",
              position: "relative",
              textAlign: "center",
              color: "white",
            }}
          >
            <img
              src={activeBanner?.url || activeBanner}
              alt={activeSystemName}
              style={{
                maxHeight: screenWidth > 900 ? "" : "75px",
                width: screenWidth > 900 ? "750px" : "330px",
                borderRadius: 2,
                filter: "brightness(50%)",
              }}
            />
            <Typography
              variant="h4"
              sx={{
                position: "absolute",
                top: screenWidth > 900 ? "45%" : "35%",
                transform: "translate(-50%, -50%",
              }}
            >
              {activeSystemName}
            </Typography>
          </ButtonBase>
        </Box>
      ) : gameSystemId ? (
        <ButtonBase
          focusRipple
          onClick={() => {
            setOpen(true);
          }}
          sx={{
            width: "100%",
            height: screenWidth > 900 ? "125px" : "80px",
            overflowX: "hidden",
            borderRadius: 1,
          }}
        >
          <img
            src={activeBanner?.url || activeBanner}
            alt={activeSystemName}
            style={{ maxHeight: "100%", borderRadius: 2 }}
          />
        </ButtonBase>
      ) : (
        <Button variant="contained" fullWidth onClick={() => setOpen(true)}>
          Select Game System
        </Button>
      )}
      {open && (
        <Modal
          disableAutoFocus
          open={open}
          onClose={() => {
            setOpen(false);
          }}
          closeAfterTransition
          BackdropComponent={Backdrop}
          BackdropProps={{
            timeout: 500,
          }}
        >
          <Box
            sx={{
              position: "absolute",
              left: "50%",
              transform: "translate(-50%, 0%)",
              maxHeight: "95vh",
              overflowY: "auto",
              bgcolor: "background.paper",
              borderRadius: 1,
              boxShadow: 24,
              p: 4,
              width: "85vw",
              top: "65px",
              height: "calc(100vh - 80px)",
            }}
          >
            <IconButton
              aria-label="cancel"
              color="error"
              sx={{ position: "absolute", top: "4px", right: "4px" }}
              onClick={() => {
                setOpen(false);
              }}
            >
              <BCPXmark />
            </IconButton>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography
                  variant="h3"
                  gutterBottom
                  sx={{ textTransform: "uppercase" }}
                >
                  Choose Game System
                </Typography>
              </Grid>

              {gameSystems?.length > 0 && (
                <Grid
                  container
                  spacing={1}
                  sx={{
                    p: 1,
                    overflowX: "hidden",
                    m: 0,
                  }}
                >
                  {gameSystems.map((gameSystem, index) => {
                    return (
                      <ModalListItem
                        gameSystem={gameSystem}
                        setGameSystemId={setGameSystemId}
                        setActiveBanner={setActiveBanner}
                        setActiveSystemName={setActiveSystemName}
                        setOpen={setOpen}
                        screenWidth={screenWidth}
                        handleChange={handleChange}
                        valueType={valueType}
                        name={name}
                        key={index}
                      />
                    );
                  })}
                </Grid>
              )}
            </Grid>
          </Box>
        </Modal>
      )}
    </>
  );
}
